import type { TargetId } from "@common/target/types"

export interface TargetConfig {
  factory: string
  faucet?: string
  explorer?: string
  cw20s: TargetConfigCw20[]
  faucetGasAmount?: string
  faucetCollateralAmount: Record<string, string>
  maintenance?: MaintenanceMessage
}

export interface TargetConfigCw20 {
  address: string
  denom: string
  decimals: number
}

export type MaintenanceMessage = "general" | "sei-unstable"

export const mainnetTargetConfig = async (
  targetId: TargetId,
): Promise<TargetConfig> => {
  switch (targetId) {
    case "rujimainnet1": {
      return {
        factory:
          "thor1gclfrvam6a33yhpw3ut3arajyqs06esdvt9pfvluzwsslap9p6uqt4rzxs",
        cw20s: [],
        faucetCollateralAmount: {},
        explorer: "https://thorchain.net/tx/",
      }
    }
    default:
      throw new Error(
        `No local target configs are available, tried to load: ${targetId}`,
      )
  }
}
